export default "__VITE_ASSET__Baf$xdMG__"